import OnlineOrderValuesModel from "../../../../services/models/formModels/onlineOrderValues.model";
import CustomText from "../../../atomic/CustomText";
import DetailRenderer from "../DetailRenderer";

function AdditionalInformationReview({
  values,
}: {
  values: OnlineOrderValuesModel;
}) {
  if (values?.additionalClinician?.length === 0) {
    return <div></div>;
  }
  return (
    <div id="additional info">
      <CustomText
        text={"Additional Information"}
        fontWeight="font-medium"
        className="reviewCardHeading my-5"
      />
      <div className="reviewCard">
        {values?.additionalClinician?.map((e, index) => (
          <div key={e.firstName + index}>
            <CustomText
              text={`Additional Clinician ${index + 1}`}
              fontWeight="font-medium"
              className="my-5"
            />
            <DetailRenderer
              data={e}
              groupFields={["firstName", "lastName", "npi", "fax", "email", "phone"]}
              hiddenFields={["id", "status", "physician"]}
              inlineFields={true} // This will make all fields appear inline
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default AdditionalInformationReview;
